import { CSSProperties } from 'react';

export const ContainerStyle: CSSProperties = {
  position: 'absolute',
  background: 'white',
  zIndex: 9999,
  width: '100%',
  height: '100%',
  left: 0,
};

export const HeaderStyle: CSSProperties = {
  position: 'absolute',
  zIndex: 999999999,
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  padding: '10px',
  width: '100%',
  background: 'rgba(255, 255, 255, 0.5)',
  height: '100px',
};

export const ButtonGroupStyle: CSSProperties = {
  display: 'flex',
  gap: '10px',
};

export const MainContentStyle: CSSProperties = {
  marginTop: '100px',
};
